<era-device-grid-ui [devices]="unavailableDevices$ | async"
                    (selected)="itemSelected($event)">
  <div class="title">
    <h6>Unavailable</h6>
  </div>
  <div class="empty">
    <p>No unavailable devices.</p>
  </div>
</era-device-grid-ui>